import React from 'react'
import RecipeHeaders from "./recipeHeaders/RecipeHeaders";
import RecipeItems from "./recipeItemList/RecipeItems";
import {Col, Row} from "antd";
import RecipeItemsMidTotal from "./recipeItemList/RecipeItemsMidTotal";
import RecipeProductionCost from "./recipeProductionCosts/RecipeProductionCosts";
import RecipeProductionMidTotal from "./recipeProductionCosts/RecipeProductionMidTotal";

const RecipeInformationContainer = () => {

    return (
        <React.Fragment>
            <Row>
                <Col span={24}>
                    <RecipeHeaders />
                </Col>
                <Col span={24}>
                    <RecipeItems/>
                </Col>
            </Row>
            <Row justify={'end'}>
                <Col span={10}>
                    <RecipeItemsMidTotal/>
                </Col>
            </Row>
            <Row>
                <Col span={24}>
                    <RecipeProductionCost/>
                </Col>
            </Row>
            <Row justify={'end'}>
                <Col span={10}>
                    <RecipeProductionMidTotal />
                </Col>
            </Row>
        </React.Fragment>
    )
}
export default RecipeInformationContainer